import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import FlexView from 'react-flexview/lib';
import { GridResultsScreen } from './Grid/GridResultsScreen';
import { EuiSpacer } from '@elastic/eui';
import FormularioProyectos from './Formulario/container';
import { ActionType, CREATE, UPDATE } from './constants';
import { Action } from '../../components/Menus/interface';
import { Menu } from '../../components/Menus';
import ModalApp from '../../components/Modal';
import { useUserSettings } from '../../context/CurrentUserContext';
import { MaskLoad } from '../../components/Layout';

interface Props {
  data: any;
  loadState: any;
  handleCreate(proyecto: any): any;
  handleRemove(idProyecto: number): any;
  handleUpdate(proyecto: any): any;
}

const ProyectosScreen = (props: Props) => {
  const ref:any = useRef();
  const {currentUser}=useUserSettings();

  let { data, handleCreate, handleRemove, handleUpdate, loadState } = props;
  let [isModalVisible, setIsModalVisible] = useState(false);
  let [selected, setSelected] = useState<any>(undefined);
  let [actionType, setActionType] = useState<ActionType>(CREATE);
 

  useEffect(()=>{
    closeModal();
    setSelected(undefined)
  },[data])

  const closeModal = () => setIsModalVisible(false);
  const showModal = () => setIsModalVisible(true);

  const prepareCreate = useCallback(() => {
    setActionType(CREATE);
    showModal();
  },[])

  const prepareEdit = useCallback(() => {
    setActionType(UPDATE);
    showModal();
  },[])

  const onCreate = useCallback((newData: any) => {
    if (newData && handleCreate) {
      handleCreate(newData)
    }
  },[handleCreate])

  const onRemove = useCallback(() => {
    if (selected && handleRemove) {
      handleRemove(selected.idProyecto)
    }
  },[selected, handleRemove])

  const onUpdate = useCallback((newData: any) => {
    if (handleUpdate && newData) {
      handleUpdate(newData)
    }
  },[handleUpdate])

  const onSelected = (selection: any) => {
    setSelected(selection[0])
  }

  const onFilterClear = () => { 
    ref.current && ref.current.onFilterClear()
  }

  const getSelected = useMemo(() =>{
    return actionType.tipo === "U" ? selected : undefined;
  },[actionType,selected])

  const getHandle = useCallback(() =>{
    if(actionType.tipo === "I"){
      return onCreate
    }else{
      return onUpdate
    }
  },[actionType,onUpdate])

  const Actions: Action[] = useMemo(()=>[
    {handle:onFilterClear,text:"Limpiar Filtro",size:"s", isDisabled: false, className: "btnFilterClear"},
    // {handle:onRemove,text:"Eliminar Selección",color:"danger",size:"s", isDisabled:(selected===undefined)},
    {handle:prepareEdit,text:"Editar Selección",color:"secondary",size:"s",isDisabled:(selected===undefined)},
    {handle:prepareCreate,text:"Nuevo Proyecto",color:"primary",size:"s", isDisabled:false}
  ],[selected, onRemove, prepareEdit])

  const contentModal = useCallback(() => <FormularioProyectos handle={getHandle()} selected={getSelected} onClose={closeModal} 
  currentUser={currentUser}/>,[getHandle,getSelected])

  const modal = useMemo(() => <ModalApp isOpen={isModalVisible} title={actionType.title} onClose={closeModal} content={contentModal()}/> ,[isModalVisible,actionType,contentModal])

  const getView = useMemo(() => {
    return (
      <>
        <GridResultsScreen
          data={data}
          selector={false}
          onSelected={onSelected}
          onChange={onUpdate}
          ref={ref}
        />
        { modal }
      </>
    )
  },[data,modal,onUpdate])

  return (
    <FlexView column basis="100%">
        <FlexView column shrink={0} basis="50%" vAlignContent="center" hAlignContent="right">
          <Menu actions={Actions}/>
          <EuiSpacer size="s" />
        </FlexView>
      <FlexView grow={1} shrink={1} basis="auto">
        <FlexView column shrink={0} basis="100%">
          {getView}
        </FlexView>
      </FlexView>
       <MaskLoad isLoading={loadState.isLoading} text={loadState.label}/>
    </FlexView>
  );
};

export default ProyectosScreen;
